import React from "react";
import clsx from "clsx";

type InputProps = {
  label?: string;
  type?: string;
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  step?: string | number; // ✅ allow step
};

export const Input: React.FC<InputProps> = ({
  label,
  type = "text",
  value,
  onChange,
  className,
  placeholder,
  disabled,
  required,
  error,
  step,
}) => (
  <div className={clsx("mb-4", className)}>
    {label && (
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
    )}
    <input
      type={type}
      value={value}
      onChange={onChange}
      className="block w-full rounded border-gray-300 shadow-sm focus:ring focus:ring-blue-200 focus:border-blue-500 p-2"
      placeholder={placeholder}
      disabled={disabled}
      required={required}
	  step={step} // ✅ forward to native input
    />
	 {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
  </div>
);
